module.exports = __webpack_public_path__ + "img/61.609406a1.jpg";